import { render, staticRenderFns } from "./ScoreParams.vue?vue&type=template&id=59110505&scoped=true&lang=pug"
import script from "./ScoreParams.vue?vue&type=script&lang=js"
export * from "./ScoreParams.vue?vue&type=script&lang=js"
import style0 from "./ScoreParams.vue?vue&type=style&index=0&id=59110505&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59110505",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59110505')) {
      api.createRecord('59110505', component.options)
    } else {
      api.reload('59110505', component.options)
    }
    module.hot.accept("./ScoreParams.vue?vue&type=template&id=59110505&scoped=true&lang=pug", function () {
      api.rerender('59110505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profiling/ScoreParams.vue"
export default component.exports